import { Badge, type SemanticTone } from '@kerfjs/ui/badge';
import { type SafeHtml } from 'kerfjs';

const STATUS_TONE: Record<string, SemanticTone> = {
  draft: 'neutral',
  submitted: 'info',
  quoting: 'warning',
  analysed: 'info',
  decided: 'success',
  closed: 'neutral',
  rejected: 'danger',
  returned: 'warning',
  cancelled: 'danger',
};

export function StatusBadge({ status, label }: { status: string; label: string }): SafeHtml {
  return (
    <Badge
      tone={STATUS_TONE[status] ?? 'neutral'}
      appearance="solid"
      shape="pill"
      rootAttributes={{ 'data-status': status }}
    >
      {label}
    </Badge>
  );
}
